import { create } from 'zustand';
import type { Insurance } from '~/@types/insurance';

const INITIAL_STATE_FORM = {
  page: 0,
  paymentMethod: null,
  installment: null,
  creditCard: null,
  accountDebit: null,
  insuranceFormData: null,
};

type State = {
  page: number;
  form: Checkout.Form | null;
  insuranceFormData: any;
  contractSeller: Checkout.ContractSeller | null;
  insurance: Insurance.Information | null;
  init: (insurance: Insurance.Information) => void;
  setPaymentMethod: (paymentMethod: Checkout.PaymentMethod) => void;
  setInstallment: (installment: Checkout.Installment) => void;
  setCreditCard: (creditCard: Checkout.CreditCard) => void;
  setAccountDebit: (accountDebit: Checkout.AccountDebit) => void;
  setContractSeller: (contractSeller: Checkout.ContractSeller | null) => void;
  setPage: (page: number) => void;
  setInsuranceFormData: (data: any) => void;
  finish: (userDocument: string | undefined) => Promise<boolean>;
};

const updateForm = (
  state: State,
  field: keyof Checkout.Form,
  value: any
): State => {
  return {
    ...state,
    form: { ...(state.form || { ...INITIAL_STATE_FORM }), [field]: value },
  };
};

const useCheckout = create<State>((set, get) => ({
  page: 0,
  form: { ...INITIAL_STATE_FORM },
  insurance: null,
  insuranceFormData: null,
  contractSeller: null,
  init: (insurance: Insurance.Information) => {
    if (insurance) {
      set({
        page: 0,
        form: {
          ...INITIAL_STATE_FORM,
        },
        insurance,
      });
    }
  },
  setPaymentMethod: (paymentMethod) =>
    set((state) => updateForm(state, 'paymentMethod', paymentMethod)),
  setInstallment: (installment) =>
    set((state) => updateForm(state, 'installment', installment)),
  setCreditCard: (creditCard) =>
    set((state) => updateForm(state, 'creditCard', creditCard)),
  setAccountDebit: (accountDebit) =>
    set((state) => updateForm(state, 'accountDebit', accountDebit)),
  setContractSeller: (contractSeller) => set({ contractSeller }),
  setPage: (page) => set({ page }),
  setInsuranceFormData: (formData) => {
    const { insuranceFormData } = get();

    set({ insuranceFormData: { ...insuranceFormData, ...formData } });
  },
  finish: async (userDocument: string | undefined) => {
    const { insurance, insuranceFormData, contractSeller, form } = get();

    if (insurance && insuranceFormData && form) {
      const { doCheckout, onSuccess } = insurance;

      const response = await doCheckout?.(
        { ...insuranceFormData, userDocument, contractSeller },
        form
      );
      onSuccess?.(response);
      return true;
    }
    throw { message: 'Erro interno' };
  },
}));

export default useCheckout;
